/**
 * Runtime configuration. Only the publishable (anon) key may ever reach the browser;
 * the service-role key must never be configured here.
 *
 * Security review L3: demo mode only when VITE_DEMO=true is set explicitly (`pnpm build` / `pnpm dev:demo`
 * via .env.demo). Otherwise missing Supabase env is a hard error — no silent fallback to demo data.
 */
export interface AppConfig {
  mode: 'demo' | 'supabase';
  supabaseUrl: string | null;
  supabasePublishableKey: string | null;
}

export function readConfig(env: Record<string, string | boolean | undefined> = import.meta.env): AppConfig {
  const demo = String(env.VITE_DEMO ?? '').trim() === 'true';
  if (demo) return { mode: 'demo', supabaseUrl: null, supabasePublishableKey: null };
  const url = String(env.VITE_SUPABASE_URL ?? '').trim() || null;
  const key = String(env.VITE_SUPABASE_PUBLISHABLE_KEY ?? '').trim() || null;
  if (!url || !key) {
    throw new Error('Configuratiefout: VITE_SUPABASE_URL/VITE_SUPABASE_PUBLISHABLE_KEY ontbreken (zet VITE_DEMO=true voor demomodus).');
  }
  return { mode: 'supabase', supabaseUrl: url, supabasePublishableKey: key };
}

export const config = readConfig();
